import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { RolesModel } from '../../../../Data/Models/Users/roles-model';
import { MaterialModule } from '../../../../material.module';
import { UsermanagementService } from '../../../../services/apps/usermanagement/usermanagement.service';
import { CharitiesService } from '../../charities/services/charities.service';
import { CharityDataShareServiceService } from '../../charities/services/charity-data-share-service.service';
import { SelectedNotesmodel } from '../models/selected-notesmodel';
import { NotesApiService } from '../services/notes-api.service';
import { NotesDatashareService } from '../services/notes-datashare.service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { MessageServiceService } from '../../../../Shared/common/message-service.service';

@Component({
  selector: 'app-account-notes',
  imports: [TablerIconsModule, MaterialModule, CommonModule, RouterModule, MatTabsModule, FormsModule, MatSlideToggleModule],
  templateUrl: './account-notes.component.html',
  styleUrl: './account-notes.component.scss'
})
export class AccountNotesComponent {
  selectedNotes: string[] = ['Note1', 'Note2', 'Note11'];
  LYselectedNotes: string[] = [];
  SavedselectedNotes: string[] = ['Note1', 'Note2', 'Note11'];
  jumpsection = 'note1'
  notesdata: SelectedNotesmodel = new SelectedNotesmodel()
  isChecked = false; isChecked2 = false; isChecked3 = false; isChecked4 = false; isChecked5 = false; isChecked6 = false; isChecked7 = false; isChecked8 = false;
  financialYear: string | null;
  accounting_Method: string | number | null;
  apFinalised: boolean = false
  Charity_Type: string | null;
  baseURL: string;
  Account_Type: string | null;
  IsCYSelectAll: boolean = false;
  SubmissionStatus: any;
  BasicInformation: any = [];
  ShowSpinner: any = false;
  // Fullnamenotes: string[]=[];
  constructor(private Charity_Service: CharitiesService, private datashare: NotesDatashareService, private apiservice: NotesApiService, private configService: ConfigurationService,
    private router: Router, private _UsermanagementService: UsermanagementService, private sharedService: CharityDataShareServiceService, private msgService: MessageServiceService) {
    this.Account_Type = localStorage.getItem('account_Type')

    this.accounting_Method = localStorage.getItem('accounting_Method') != '' ? localStorage.getItem('accounting_Method') : ''
    debugger
    this.baseURL = this.configService.getAPIBaseUrl();
    if (this.baseURL.includes('localhost')) {
      this.Fullnamenotes = [
        { code: 'Note30', name: 'Note 30: Revised Statements' },
        { code: 'Note1', name: 'Note 1: General Information' },
        { code: 'Note2', name: 'Note 2: Accounting Polices' },
        { code: 'Note3', name: 'Note 3: Analysis of Income' },
        { code: 'Note4', name: 'Note 4: Analysis of Receipts of Government Grants' },
        { code: 'Note5', name: 'Note 5: Donated Goods, Facilities and Services' },
        { code: 'Note6', name: 'Note 6: Analysis of Expenditure' },
        { code: 'Note7', name: 'Note 7: Extraordinary Items' },
        { code: 'Note8', name: 'Note 8: Funds Received as Agent' },
        { code: 'Note9', name: 'Note 9: Support Costs' },
        { code: 'Note10', name: 'Note 10: Fees for examination of the accounts' },
        { code: 'Note11', name: 'Note 11: Paid Employees' },
        { code: 'Note12', name: 'Note 12: Pension Scheme' },
        { code: 'Note13', name: 'Note 13: Grantmaking' },
        { code: 'Note14', name: 'Note 14: Tangible Fixed Assets' },
        { code: 'Note15', name: 'Note 15: Intangible Assets' },
        { code: 'Note16', name: 'Note 16: Heritage Assets' },
        { code: 'Note17', name: 'Note 17: Investment Assets' },
        { code: 'Note18', name: 'Note 18: Stocks' },
        { code: 'Note19', name: 'Note 19: Debtors and Prepayments' },
        { code: 'Note20', name: 'Note 20: Creditors and Accruals' },
        { code: 'Note21', name: 'Note 21: Provisions for Liabilities and Charges' },
        { code: 'Note22', name: 'Note 22: Disclosures for Debtors & Creditors' },
        { code: 'Note23', name: 'Note 23: Contingent Liabilities and Contingent Assets' },
        { code: 'Note24', name: 'Note 24: Cash and Cash equivalents' },
        { code: 'Note25', name: 'Note 25: Fair Value of Assets and Liabilities' },
        { code: 'Note26', name: 'Note 26: Events after the end of the reporting period' },
        { code: 'Note27', name: 'Note 27: Charity Funds' },
        { code: 'Note28', name: 'Note 28: Transactions with Trustees and Related Parties' },
        { code: 'Note29', name: 'Note 29: Additional Disclosures' },
      ]
    }
    if (this.Account_Type === 'Amended') {
      this.jumpsection = 'note30'
    }

  }


  ngOnInit() {
    //this.sharedService.finalStatus$.subscribe((value: any) => {
    //  this.apFinalised = value != '' && value == 'Completed'
    //})
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    this.Charity_Type = localStorage.getItem('Charity_Type') != '' ? localStorage.getItem('Charity_Type') : ''
    //if (this.Charity_Type == 'Unincorporated Charity' && this.accounting_Method == 'Cash (Receipts & Payments)') {
    //  this.selectedNotes = []
    //}
    this.syncNote30WithAccountType();
    if (!this.selectedNotes.includes(this.jumpsection)) {
      this.jumpsection = this.selectedNotes[0];
    }
    this.GetUserAccess()
    this.financialYear = localStorage.getItem('FY_Year');
    this.datashare.setSelectedNotes([...this.selectedNotes]);
    this.datashare.selectedNotes$.subscribe(notes => {
      if (notes?.length != 0) {
        this.selectedNotes = notes;
        this.syncNote30WithAccountType();
      }
    });

    this.Getnotes()
    this.Getbasicinformation()

  }


  UserRoleAccess: RolesModel;

  GetUserAccess() {
    this.ShowSpinner = true;
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      debugger
      if (data.entity.length) {
        this.ShowSpinner = false;
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
      this.sharedService.finalStatus$.subscribe((value: any) => {
        this.apFinalised = value != '' && value == 'Completed'
      })
    });
  }


  Fullnamenotes = [
    { code: 'Note30', name: 'Revised Statements' },
    { code: 'Note1', name: 'General Information' },
    { code: 'Note2', name: 'Accounting Polices' },
    { code: 'Note3', name: 'Analysis of Income' },
    { code: 'Note4', name: 'Analysis of Receipts of Government Grants' },
    { code: 'Note5', name: 'Donated Goods, Facilities and Services' },
    { code: 'Note6', name: 'Analysis of Expenditure' },
    { code: 'Note7', name: 'Extraordinary Items' },
    { code: 'Note8', name: 'Funds Received as Agent' },
    { code: 'Note9', name: 'Support Costs' },
    { code: 'Note10', name: 'Fees for examination of the accounts' },
    { code: 'Note11', name: 'Paid Employees' },
    { code: 'Note12', name: 'Pension Scheme' },
    { code: 'Note13', name: 'Grantmaking' },
    { code: 'Note14', name: 'Tangible Fixed Assets' },
    { code: 'Note15', name: 'Intangible Assets' },
    { code: 'Note16', name: 'Heritage Assets' },
    { code: 'Note17', name: 'Investment Assets' },
    { code: 'Note18', name: 'Stocks' },
    { code: 'Note19', name: 'Debtors and Prepayments' },
    { code: 'Note20', name: 'Creditors and Accruals' },
    { code: 'Note21', name: 'Provisions for Liabilities and Charges' },
    { code: 'Note22', name: 'Disclosures for Debtors & Creditors' },
    { code: 'Note23', name: 'Contingent Liabilities and Contingent Assets' },
    { code: 'Note24', name: 'Cash and Cash equivalents' },
    { code: 'Note25', name: 'Fair Value of Assets and Liabilities' },
    { code: 'Note26', name: 'Events after the end of the reporting period' },
    { code: 'Note27', name: 'Charity Funds' },
    { code: 'Note28', name: 'Transactions with Trustees and Related Parties' },
    { code: 'Note29', name: 'Additional Disclosures' },
  ]


  getFilteredFullNames(): any[] {
    if (this.Account_Type === 'Amended') {
      return this.Fullnamenotes.filter(note =>
        note.code === 'Note30' || this.selectedNotes.includes(note.code)
      );
    }

    return this.Fullnamenotes.filter(note =>
      this.selectedNotes.includes(note.code)
    );
  }

  backToBalanceSheet() {
    this.router.navigate(['balancesheet']);

  }
  backToAssets() {
    debugger
    this.router.navigate(['assets-statements']);
  }
  selectnote(note: string, event?: any) {
    debugger

    if (!this.selectedNotes.includes(note)) {
      this.selectedNotes.push(note)

    }

    else {

      this.selectedNotes = this.selectedNotes.filter(item => (item != note))
      this.datashare.setSelectedNotes([...this.selectedNotes]);
    }
  }
  add(note: string) {
    this.datashare.addNote(note);
  }
  backToCharityOverView() {
    debugger
    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);

  }

  selectAllNotes1(_event: any) {
    debugger
    this.IsCYSelectAll = _event.checked
    if (_event.checked == true) {
      if (this.Account_Type === 'Amended') {
        this.selectedNotes = this.Fullnamenotes.map(note => note.code);
      }
      else {

        this.selectedNotes = this.Fullnamenotes
          .filter(note => note.code !== 'Note30')
          .map(note => note.code);
      }

    } else {

      this.selectedNotes = ['Note1', 'Note2', 'Note11'];

      if (this.Account_Type === 'Amended') {
      }

    }
    this.syncNote30WithAccountType();
    if (!this.selectedNotes.includes(this.jumpsection)) {
      this.jumpsection = this.selectedNotes[0];
    }
    this.datashare.setSelectedNotes([...this.selectedNotes]);
  }
  LYselectAllNotes1(_event: any) {
    if (_event == true) {
      this.selectedNotes = this.LYselectedNotes.map(note => note);
      this.syncNote30WithAccountType();
    } else {
      if (this.IsCYSelectAll) {
        this.selectedNotes = this.Fullnamenotes.map(note => note.code);
      }
      else {
        this.selectedNotes = this.SavedselectedNotes;
      }
    }
    if (!this.selectedNotes.includes(this.jumpsection)) {
      this.jumpsection = this.selectedNotes[0];
    }
    this.datashare.setSelectedNotes([...this.selectedNotes]);
  }

  onSelectAllToggle(event: any, method: 'accruals' | 'cash') {
    debugger
    if (event.checked) {
      if (method === 'accruals') {
        this.selectedNotes = this.Fullnamenotes.map(note => note.code);
      } else {
        if (this.Account_Type == 'Amended') {
          this.selectedNotes = this.Fullnamenotes
            .filter(note => note.code !== 'Note3' && note.code !== 'Note6')
            .map(note => note.code);
        }
        else {
          this.selectedNotes = this.Fullnamenotes
            .filter(note => note.code !== 'Note3' && note.code !== 'Note6' && note.code !== 'Note30')
            .map(note => note.code);
        }
      }
    } else {
        this.selectedNotes = ['Note1', 'Note2', 'Note11'];
        if (this.Account_Type === 'Amended') {
        }
    }
  }

  isAllNotesSelected(method: 'accruals' | 'cash'): boolean {
    var total = 0
    if (this.Account_Type == 'Amended') {
      total = this.Fullnamenotes.filter(note => note.code !== 'Note3' && note.code !== 'Note6').length;
    }
    else {
      total = this.Fullnamenotes.filter(note => note.code !== 'Note3' && note.code !== 'Note6' && note.code !== 'Note30').length;
    }

    return this.selectedNotes.length >= total;
  }
  remove(note: string) {
    this.datashare.removeNote(note);
  }

  save() {
    debugger;

    const uid = localStorage.getItem('CurrentuserID');
    const cid = localStorage.getItem('CentralUserId');
    const fid = localStorage.getItem('currentPeriod');


    if (this.Account_Type === 'Amended' && !this.selectedNotes.includes('Note30')) {
      this.selectedNotes.unshift('Note30');
    }
    this.syncNote30WithAccountType();
    this.notesdata.note = this.selectedNotes.filter(
      note => note && !note.includes('trusteeannualreport')
    );

    this.notesdata.centralUserId = cid ? +cid : 0;
    this.notesdata.financialPeriodsID = fid ? +fid : 0;
    this.notesdata.userId = uid ? +uid : 0;

    this.apiservice.saveSelectedNotesDetails(this.notesdata)
      .subscribe(() => {
        if (!this.selectedNotes.includes(this.jumpsection)) {
          this.jumpsection = this.selectedNotes[0];
        }
        this.datashare.setSelectedNotes([...this.selectedNotes]);

        if (!this.jumpsection || this.jumpsection === 'Select Notes Section') {
          return;
        }


        const nextnote = this.jumpsection.toLowerCase();
        const url = `/charity/notes/${nextnote}`;


        this.datashare.setSubTab(1);

        if (nextnote === 'note30') {
          this.datashare.setisActive(1);
          this.router.navigateByUrl('/charity/notes/note30');
        } else {
          this.datashare.setisActive(1);
          this.router.navigate([url]);
        }
      });
  }




  Getnotes() {

    debugger

    var fid = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0

    this.apiservice.GetSelectedNotesDetails(fid).subscribe((data: any) => {

      if (data.note.length > 1) {
        this.selectedNotes = data.note
        this.datashare.setSelectedNotes([...this.selectedNotes]);
        if (this.Account_Type !== 'Amended') {
          this.selectedNotes = this.selectedNotes.filter(n => n !== 'Note30');
        }
        if (!this.selectedNotes.includes(this.jumpsection)) {
          this.jumpsection = this.selectedNotes[0];
        }
        this.syncNote30WithAccountType();

        if (this.Account_Type == 'Amended' && !data.note.includes("Note30")) {
        }

        if (this.Account_Type === 'Amended' && !this.selectedNotes.includes('Note30')) {
          this.selectedNotes.unshift('Note30');
        }


        this.SavedselectedNotes = [...this.selectedNotes];
        this.selectedNotes = this.selectedNotes.filter((item: any) => item != 'trusteeannualreport')
        this.SavedselectedNotes = this.selectedNotes.filter((item: any) => item != 'trusteeannualreport')
      }

      if (this.Account_Type === 'Amended' && this.selectedNotes.includes('Note30')) {
        this.ensureNote30Selected();
        this.jumpsection = 'Note30';
      } else {
        this.jumpsection = this.selectedNotes[0];
      }

      this.LYselectedNotes = data.lyNote

      if (this.Account_Type === 'Amended') {
        this.jumpsection = 'Note30';
      } else if (this.selectedNotes?.length) {
        this.jumpsection = this.selectedNotes[0];
      }

    })

  }
  BringForwardNotes(_event: any) {
    Swal.fire({
      html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Bring Forward Notes</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px; padding-right:40px !important"> Are you sure you want to proceed?<br> This will overwrite your current selections with the data from the previous financial year.</p>',
      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No",
      allowOutsideClick: false,
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        debugger
        this.LYselectAllNotes1(true)
        this.syncNote30WithAccountType();

        +this.datashare.setSelectedNotes([...this.selectedNotes]);

      }
      else {
        debugger
      }
    })
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid,'UnlockandAmend').subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
            this.selectnote("Note30")
            this.Account_Type = 'Amended'
            localStorage.setItem('NewAmendCycle', 'true');
            this.syncNote30WithAccountType();
            this.jumpsection = 'Note30';
          })
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid,'Unlock').subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')

          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }
  Getbasicinformation() {


    var fid = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    const charityId = localStorage.getItem('currentCharityID');
    this.Charity_Service.Getbasicinfo(charityId, fid).subscribe((data: any) => {
      debugger
      this.BasicInformation = data
      if (this.BasicInformation && this.BasicInformation.length > 0) {

        const info = this.BasicInformation[0];
        localStorage.setItem('accounting_Method', this.BasicInformation[0].accounting_Method.toString());
        this.accounting_Method = localStorage.getItem('accounting_Method') != '' ? localStorage.getItem('accounting_Method') : ''
      }


    })
  }

  private ensureNote30Selected(): void {
    if (this.Account_Type === 'Amended' && !this.selectedNotes.includes('Note30')) {
      this.selectedNotes.unshift('Note30');
    }
  }


  private ensureRevisedStatements(): void {
    if (this.Account_Type === 'Amended') {
      if (!this.selectedNotes.includes('Note30')) {
        this.selectedNotes.unshift('Note30');
      }
      this.jumpsection = 'Note30';
    }
  }

  onJumpSelection(noteCode: string, event: any) {
    if (!event.isUserInput) {
      return;
    }

    this.jumpsection = noteCode;
    this.save();
  }

  private syncNote30WithAccountType(): void {
    if (this.Account_Type === 'Amended') {
      if (!this.selectedNotes.includes('Note30')) {
        this.selectedNotes.unshift('Note30');
      }
    } else {
      this.selectedNotes = this.selectedNotes.filter(n => n !== 'Note30');
      if (this.jumpsection === 'Note30' || this.jumpsection === 'note30') {
        this.jumpsection = this.selectedNotes[0] || 'Note1';
      }
    }
  }

}
